/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Spark submit parameters for a Spark job
*/
export class SparkJobSparkSubmitParams {
  /**
  * The entry point for the Spark application (e.g., S3 path to JAR or Python script)
  */
  'entryPoint': string;
  /**
  * Arguments to pass to the entry point
  */
  'entryPointArguments'?: Array<string> | null;
  /**
  * Additional Spark submit parameters as a string
  */
  'sparkSubmitParameters'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "entryPoint",
      "baseName": "entryPoint",
      "type": "string",
      "format": ""
    },
    {
      "name": "entryPointArguments",
      "baseName": "entryPointArguments",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "sparkSubmitParameters",
      "baseName": "sparkSubmitParameters",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SparkJobSparkSubmitParams.attributeTypeMap;
  }

  public constructor() {
  }
}

